/**
 * Platform helper. Components and services branch through this — never by
 * sniffing user-agent strings or importing Capacitor directly.
 *
 * On web, every flag is `false` and `name` is `'web'`. On native, the
 * Capacitor runtime answers truthfully.
 */

import { Capacitor } from '@capacitor/core';

export type PlatformName = 'ios' | 'android' | 'web';

export const platform = {
  get name(): PlatformName {
    return Capacitor.getPlatform() as PlatformName;
  },
  get isNative(): boolean {
    return Capacitor.isNativePlatform();
  },
  get isWeb(): boolean {
    return !Capacitor.isNativePlatform();
  },
  get isIOS(): boolean {
    return Capacitor.getPlatform() === 'ios';
  },
  get isAndroid(): boolean {
    return Capacitor.getPlatform() === 'android';
  },
  /** Cheap check before calling a plugin — avoids throws on web. */
  isPluginAvailable(name: string): boolean {
    return Capacitor.isPluginAvailable(name);
  },
};
